import './Footer.scss';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="container">
        <p className="main-footer__text">
          Built by{" "}
          <a
            className="main-footer__link"
            href="https://github.com/sivaprasadraj"
            target="_blank"
            rel="noopener noreferrer"
          >
            Siva Bandi
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
